import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import names from 'root/global_configs/names.json';
import { populateESeriesLinkParams } from 'root/core/eSeriesLinkSwapping';
import { removeEcomFromPCPages } from 'root/core/removeEcomFromPCPages';
import { hideGolfFormOptionOnPCPages } from 'root/helpers/formHelpers';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import {
    FormGTMObjectConstructor,
    getPlacement,
} from 'root/utils/tracking/GA4/formTracking';

export default class FormElementsController {
    readonly #formEl: HTMLFormElement | null;
    readonly #formGTMObjectConstructor: FormGTMObjectConstructor;

    constructor(formEl: HTMLFormElement | null) {
        this.#formEl = formEl;
        if (this.#formEl)
            this.#formGTMObjectConstructor = new FormGTMObjectConstructor(this.#formEl);
    }

    #setFormDetailedHiddenFieldOnPricingPage() {
        const cm = new CookieMonster();
        const pricingPlanCookieValue = cm.getCookie(names.cookies.pricingPlan);
        const pageContainsPricingTableWithWizard = document.contains(
            document.querySelector('[data-pricing-table-wizard]')
        );
        if (pricingPlanCookieValue && pageContainsPricingTableWithWizard) {
            const formDetailed = this.#formEl?.querySelector<HTMLInputElement>(
                'input[name="form_detailed"]'
            );
            if (formDetailed && formDetailed.type === 'hidden') {
                formDetailed.value = pricingPlanCookieValue;
            }
        }
    }

    #changeFieldID() {
        if (this.#formEl) {
            const fields = this.#formEl.querySelectorAll(
                '[data-formfield=ls-form-field]'
            );
            if (fields && fields.length > 0) {
                Array.from(fields).forEach(fieldContainer => {
                    const field = fieldContainer.querySelector<
                        | HTMLInputElement
                        | HTMLSelectElement
                        | HTMLTextAreaElement
                        | HTMLButtonElement
                    >('input, select, textarea, button');
                    const fieldId = field && field.id;
                    const label = fieldContainer.querySelector<HTMLLabelElement>('label');
                    const labelFor = label && label.getAttribute('for');
                    if (fieldId && labelFor) {
                        field.setAttribute('id', `${fieldId}_lightbox`);
                        label.setAttribute('for', `${fieldId}_lightbox`);
                    }
                });
            }
        }
    }

    #setTrackingPlacement(event: Event) {
        if (this.#formEl) {
            this.#formEl.dataset.formPlacement =
                event && event.target
                    ? getPlacement(event.target as HTMLElement)
                    : getPlacement(this.#formEl);
        }
    }

    #trackLightboxOpen() {
        if (this.#formGTMObjectConstructor) {
            GoogleTagManager.sendEvent(
                this.#formGTMObjectConstructor.getFormGTMObject('form_lightbox_open')
            );
        }
    }

    #trackLightboxClose() {
        document.body.addEventListener(
            'lightboxClosed',
            () => {
                if (this.#formGTMObjectConstructor) {
                    GoogleTagManager.sendEvent(
                        this.#formGTMObjectConstructor.getFormGTMObject(
                            'form_lightbox_closed'
                        )
                    );
                }
            },
            { once: true }
        );
    }

    init(e: Event) {
        this.#setFormDetailedHiddenFieldOnPricingPage();
        this.#changeFieldID();
        this.#setTrackingPlacement(e);
        this.#trackLightboxOpen();
        this.#trackLightboxClose();

        populateESeriesLinkParams();
        removeEcomFromPCPages();
        this.#formEl && hideGolfFormOptionOnPCPages(this.#formEl);
    }
}
